import { createSlice } from "@reduxjs/toolkit";
import i18n from "../../translations/i18n";
import { message } from "antd";

const initialState = [];

export const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addToWishlistAction: (state, action) => {
      const product = action.payload;
      const wishlistItem = state.find((item) => item.id === product.id);

      if (wishlistItem === undefined) {
        state.push(product);
      }
    },
    deleteFromWishlistAction: (state, action) => {
      const product = action.payload;
      return state.filter((wishlistItem) => wishlistItem.id !== product.id);
    },
    deleteAllFromWishlistAction: () => {
      return [];
    },
    updateWishlistAction: (state, action) => {
      const products = action.payload;
      return state.reduce(function (updatedWishlist, wishlistItem) {
        const productFound = products.find(
          (product) => product.id === wishlistItem.id,
        );
        if (!!productFound && productFound.stock > 0) {
          const updatedWishlistItem = {
            ...wishlistItem,
            name: productFound.name,
            image: productFound.image,
            price: productFound.price,
            discount: productFound.discount,
            taxRate: productFound.taxRate,
            stock: productFound.stock,
          };
          updatedWishlist.push(updatedWishlistItem);
        }
        return updatedWishlist;
      }, []);
    },
  },
});

// Action creators
export const {
  addToWishlistAction,
  deleteFromWishlistAction,
  deleteAllFromWishlistAction,
  updateWishlistAction,
} = wishlistSlice.actions;

// Thunks
export const addToWishlist = (item) => (dispatch) => {
  message.success(i18n.t("added_to_wishlist"), 1);
  dispatch(addToWishlistAction(item));
};

export const deleteFromWishlist = (item) => (dispatch) => {
  message.success(i18n.t("removed_from_wishlist"), 1);
  dispatch(deleteFromWishlistAction(item));
};

export const deleteAllFromWishlist = () => (dispatch) => {
  dispatch(deleteAllFromWishlistAction());
};

export const updateWishlist = (products) => (dispatch) => {
  dispatch(updateWishlistAction(products));
};

export default wishlistSlice.reducer;
